// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20mEp","left":"styles_left__IUw6p","desktopActions":"styles_desktopActions__16_Mp","title":"styles_title__1LXRd"};